import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, LogOut, User, Building2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useBusiness } from '../contexts/BusinessContext';

/**
 * Mobile Top Navigation Bar
 * Displayed only on mobile/tablet screens (<1024px)
 */
const MobileTopNav = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const { activeBusiness } = useBusiness();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const getUserRole = () => {
    if (user?.role) {
      const role = user.role.toUpperCase();
      if (role === 'BUSINESS_OWNER') return 'OWNER';
      return role;
    }
    if (activeBusiness?.user_role) {
      return activeBusiness.user_role.toUpperCase();
    }
    if (activeBusiness?.role) {
      return activeBusiness.role.toUpperCase();
    }
    return 'USER';
  };

  const role = getUserRole();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="flex items-center justify-between px-4 py-3">
        {/* Left: Menu Button */}
        <button
          onClick={onMenuClick}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <Menu className="w-6 h-6 text-gray-700" />
        </button>

        {/* Center: Brand */}
        <div className="flex-1 text-center">
          <h1 className="text-lg font-bold text-blue-600">Billsera</h1>
          {activeBusiness && (
            <p className="text-xs text-gray-500 truncate max-w-[200px] mx-auto">
              {activeBusiness.name}
            </p>
          )}
        </div>

        {/* Right: User Menu */}
        <div className="relative">
          <button
            onClick={() => setShowUserMenu(!showUserMenu)}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <User className="w-6 h-6 text-gray-700" />
          </button>

          {showUserMenu && (
            <>
              <div
                className="fixed inset-0 z-40"
                onClick={() => setShowUserMenu(false)}
              />
              <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 z-50">
                <div className="p-4 border-b border-gray-200">
                  <p className="font-semibold text-gray-900">{user?.name || user?.email}</p>
                  <p className="text-xs text-gray-500 mt-1">{user?.email || user?.phone}</p>
                  <span className="inline-block mt-2 px-2 py-1 text-xs font-medium bg-blue-100 text-blue-700 rounded">
                    {role}
                  </span>
                </div>
                
                {activeBusiness && (
                  <div className="p-4 border-b border-gray-200">
                    <div className="flex items-center gap-2 text-sm">
                      <Building2 className="w-4 h-4 text-gray-500" />
                      <div>
                        <p className="font-medium text-gray-700">Current Business</p>
                        <p className="text-xs text-gray-500">{activeBusiness.name}</p>
                      </div>
                    </div>
                  </div>
                )}

                <div className="p-2">
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center gap-2 px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                  >
                    <LogOut className="w-4 h-4" />
                    Logout
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileTopNav;
